// Global KO view models. Used by forms, modals, etc.
var alkamiviewmodels = (function () {

    var models = {};

    models.WizardStep = function (data) {
        var self = this;

        self.id = ko.observable(data.id);
        self.template = ko.observable(data.template);
        self.isGlobalTemplate = ko.observable(data.isGlobalTemplate);
        self.isFirst = ko.observable(data.id === 0);
        self.isLast = ko.observable(data.isLast); // Multiple steps can be final steps

        self.nextCallback = data.nextCallback;
        self.backCallback = data.backCallback;
    }

    models.WizardModal = function (steps) {
        var self = this;

        /*** Observables and Computeds ***/
        self.submitting = ko.observable(false);
        self.steps = ko.observableArray([]);

        ko.utils.arrayForEach(steps, function (step) {
            self.steps.push(new models.WizardStep(step));
        });

        self.currentStep = ko.observable(self.steps()[0]); // Default to first step

        /*** Override these computeds to control movement and behavior ***/

        self.nextLabel = ko.computed(function () {
            if (self.currentStep().isLast()) {
                return self.submitting() ? 'Saving...' : 'Save';
            }

            return 'Next';
        });

        self.backLabel = ko.computed(function () {
            return 'Back';
        });

        self.nextStep = ko.computed(function () {
            // There is no next step if you are on the last step
            if (self.currentStep().isLast()) {
                return self.currentStep();
            }

            // Default to plus 1 step
            return self.steps()[(self.currentStep().id() + 1)];
        });

        self.previousStep = ko.computed(function () {
            // There is no previous step if you are on the first step
            if (self.currentStep().isFirst()) {
                return self.currentStep();
            }

            // Default to minus 1 step
            return self.steps()[(self.currentStep().id() - 1)];
        });
    
        self.canGoForward = ko.computed(function () {
            // Default to allow movement as long as you aren't submitting.
            return !self.submitting();
        });

        self.canGoBack = ko.computed(function () {
            // Default to allow movement as long as you aren't submitting.
            return !self.submitting();
        });

        /*** Movement Functions. Do not override! ***/

        self.moveForward = function () {
            if (self.canGoForward() && self.nextStep()) {

                if ($.isFunction(self.nextStep().nextCallback)) {
                    self.nextStep().nextCallback();
                }

                self.currentStep(self.nextStep());
            }
        }

        self.moveBack = function () {
            if (self.canGoBack() && self.previousStep()) {

                if ($.isFunction(self.previousStep().backCallback)) {
                    self.previousStep().backCallback();
                }

                self.currentStep(self.previousStep());
            }
        }
    }

    models.ErrorMessage = function (data) {
        var self = this;

        self.name = ko.observable(data.name); // The display name for the property.
        self.error = ko.observable(data.error); // The error message
    }

    return models;
})();